import axios from 'axios';
// // URL
// import { URL } from "../../backend";

// --------------------------------------------------------
// const API = axios.create({ baseURL: 'http://127.0.0.1:8000' })
export const API = axios.create({ baseURL: process.env.REACT_APP_API_URL })
// console.log(process.env.REACT_APP_URL)

API.interceptors.request.use(req => {
    // const { token } = JSON?.parse(localStorage?.getItem("user_info"));
    const token = window.localStorage.getItem('accessToken');
    if (token) {
        req.headers.Authorization = `Token ${token}`;
    }
    return req
})



// request interceptor (just attach token, no expiry check)
// API.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem("accessToken");
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// // response interceptor (handle 401 and refresh)
// API.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;

//         if (
//             error.response?.status === 401 &&
//             !originalRequest._retry &&
//             !originalRequest.url.includes("/auth/refresh")
//         ) {
//             originalRequest._retry = true;

//             try {
//                 const res = await axios.post("https://your-api.com/auth/refresh", {
//                     refreshToken: localStorage.getItem("refreshToken"),
//                 });

//                 const newAccessToken = res.data.accessToken;
//                 localStorage.setItem("accessToken", newAccessToken);

//                 originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//                 return axiosInstance(originalRequest);
//             } catch (err) {
//                 localStorage.removeItem("accessToken");
//                 localStorage.removeItem("refreshToken");
//                 window.location.href = "/login";
//                 return Promise.reject(err);
//             }
//         }

//         return Promise.reject(error);
//     }
// );
